import src from "IMAGE";
export default { src, width: 49, height: 36, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
